enum ProductType {
  Ecommerce = 0,
  Flight = 1,
  Hotel = 2,
  Package = 3,
  CarRental = 4,
  Automotive = 6,
  Promo = 17,
  Activity = 21,
  SportsTeam = 26,
  SoccerSportsTeam = 28,
  AmericanFootballSportsTeam = 29,
  Baseball = 60,
  Soccer = 61,
  Basketball = 62,
  AmericanFootball = 63,
  SoccerPlayer = 64,
  Hockey = 65,
  OlympicMedals = 66,
  OlympicEvent = 67,
  Other = 100,
}

enum AiProductType {
  Ecommerce = 'Ecommerce',
  Flight = 'Flight',
  Hotel = 'Hotel',
  Package = 'Package',
  CarRental = 'Car Rental',
  Automotive = 'Automotive',
  Promo = 'Promo',
  Activity = 'Activity',
  SportsTeam = 'Sports Team',
  SoccerSportsTeam = 'Soccer Team',
  AmericanFootballSportsTeam = 'American Football Team',
  Baseball = 'Baseball',
  Soccer = 'Soccer',
  Basketball = 'Basketball',
  AmericanFootball = 'American Football',
  SoccerPlayer = 'Soccer Player',
  Hockey = 'Hockey',
  OlympicMedals = 'Olympic Medal',
  OlympicEvent = 'Olympic Event',
  Other = 'Other',
}

enum ProductTypeName {
  Ecommerce = 'Ecommerce',
  Flight = 'Flight',
  Hotel = 'Hotel',
  Package = 'Package',
  CarRental = 'Car_rental',
  RealEstate = 'RealEstate',
  Car = 'Car',
  Restaurant = 'Restaurant',
  DespegarFlight = 'DespegarFlight',
  DespegarHotel = 'DespegarHotel',
  TradeInstrument = 'TradeInstrument',
  Trader = 'Trader',
  Promo = 'Promo',
  Activity = 'Activity',
  Cruises = 'Cruises',
  TelcoPlan = 'TelcoPlan',
  Destination = 'Destination',
  SportsTeam = 'SportsTeam',
  SoccerSportsTeam = 'SoccerSportsTeam',
  AmericanFootballSportsTeam = 'AmericanFootballSportsTeam',
  BaseballSportsEvent = 'BaseballSportsEvent',
  SoccerSportsEvent = 'SoccerSportsEvent',
  BasketballSportsEvent = 'BasketballSportsEvent',
  AmericanFootballSportsEvent = 'AmericanFootballSportsEvent',
  SoccerPlayer = 'SoccerPlayer',
  HockeySportsEvent = 'HockeySportsEvent',
  OlympicMedal = 'OlympicMedal',
  OlympicEvent = 'OlympicEvent',
  Other = 'Other',
  NA = 'NA',
}

enum VerticalType {
  NA = 0,
  Ecommerce,
  Retail,
  Travel,
  Automotive,
}

const sportsProductTypes = [
  ProductType.Soccer,
  ProductType.Baseball,
  ProductType.Basketball,
  ProductType.AmericanFootball,
  ProductType.Hockey,
];

const productTypeUINamesByValue: Record<ProductType, string> = {
  [ProductType.Ecommerce]: 'Ecommerce',
  [ProductType.Flight]: 'Flight',
  [ProductType.Hotel]: 'Hotel',
  [ProductType.Package]: 'Package',
  [ProductType.CarRental]: 'Car Rental',
  [ProductType.Automotive]: 'Car',
  [ProductType.Promo]: 'Promo',
  [ProductType.Activity]: 'Activity',
  [ProductType.SportsTeam]: 'Sports Team',
  [ProductType.SoccerSportsTeam]: 'Soccer Team',
  [ProductType.AmericanFootballSportsTeam]: 'American Football Team',
  [ProductType.Baseball]: 'Baseball Sports Event',
  [ProductType.Soccer]: 'Soccer Sports Event',
  [ProductType.Basketball]: 'Basketball Sports Event',
  [ProductType.AmericanFootball]: 'American Football Sports Event',
  [ProductType.SoccerPlayer]: 'Soccer Player',
  [ProductType.Hockey]: 'Hockey Sports Event',
  [ProductType.OlympicMedals]: 'Olympic Medal',
  [ProductType.OlympicEvent]: 'Olympic Event',
  [ProductType.Other]: 'Other',
};

export {ProductType, AiProductType, ProductTypeName, VerticalType, sportsProductTypes, productTypeUINamesByValue};
